/**
 * @file Case Study Parallax Image.
 */

import Rellax from 'rellax';

/**
 * Case Study Parallax Image component.
 */
const vCsParallaxImage = () => {
	const csParallaxImage = document.querySelectorAll('.a-cs-parallax-image');

	if (!csParallaxImage || !csParallaxImage.length) {
		return;
	}

	const {vLib}            = window || {};
	const parallaxImgs      = document.querySelectorAll('.a-cs-parallax-image__img');
	const runParallax       = () => [...csParallaxImage].filter((el) => window.getComputedStyle(el).getPropertyValue('float') === 'left').length && parallaxImgs.length;
	let wasParallax         = runParallax();
	const rellaxSettings    = {
		speed:      -6,
		center:     true,
		wrapper:    null,
		round:      true,
		vertical:   true,
		horizontal: false,
	};
	let rellax = false;



	/**
	 * Init Rellax.
	 */
	const initRellax = () => {
		rellax = new Rellax('.a-cs-parallax-image__img', rellaxSettings);
	};

	window.addEventListener('resize', () => {
		if (!parallaxImgs.length) {
			return;
		}

		const shouldRun = runParallax();

		if (shouldRun && !wasParallax) {
			initRellax();
		} else if (!shouldRun && wasParallax) {
			rellax.destroy();
			[...parallaxImgs].forEach(el => el.setAttribute('style', el.getAttribute('style').replace(/transform:.*?;/g, '')));
		}

		wasParallax = shouldRun;
	});

	document.addEventListener('vOverlayStateChanged', () => {
		if (!runParallax() || !parallaxImgs.length || !vLib.overlayIsOpen) {
			return;
		}

		const cachedTransforms = [];
		[...parallaxImgs].forEach((el) => {
			cachedTransforms.push([el.style.transform, el.style.opacity]);
		});
		rellax.destroy();
		[...parallaxImgs].forEach((el, i) => {
			el.style.transform = cachedTransforms[ i ][ 0 ];
			el.style.opacity   = cachedTransforms[ i ][ 1 ];
		});
	});

	document.addEventListener('vOverlayTransitioned', () => {
		if (!runParallax() || !parallaxImgs.length ) {
			return;
		}

		[...parallaxImgs].forEach(el => el.setAttribute('style', el.getAttribute('style').replace(/transform:.*?;/g, '')));
		initRellax();
	});

	document.addEventListener('vRerunParallax', () => {
		if (!rellax) {
			return;
		}

		rellax.refresh();
	})

	if (runParallax) {
		initRellax();
	}
};

export default vCsParallaxImage;
